module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-view', {
    ref: "pageView",
    attrs: {
      "slug": _vm.slug
    },
    on: {
      "reload": _vm.onReload,
      "reloaded": _vm.onReloaded,
      "loaded": _vm.onLoaded,
      "cssclass": _vm.onClass
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f5dd7f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/DynamicPage.vue
// module id = 265
// module chunks = 1